<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/users">Users</router-link>
                    </li>
                    <template v-if="!user.id">
                        <vue-headful :title="'Create User - AMOS365'" />

                        <li class="breadcrumb-item active" aria-current="page">Create</li>
                    </template>
                    <template v-else>
                        <vue-headful :title="'[Edit User] ' + user.first_name + ' '+user.last_name+' - AMOS365'" />

                        <li class="breadcrumb-item">
                            <router-link :to="`/users/view/${user.id}`">{{ user.first_name }} {{ user.last_name }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Edit</li>
                    </template>

                </ol>
            </nav>

            <h4 class="page-header">
                <span v-if="id">Edit: {{ user.first_name }} {{ user.last_name }}</span>
                <span v-else>New User</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.first_name, 'text-muted-no': !errors.first_name}">
                                    First Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!user.first_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="user.first_name" :class="{'form-control': true, 'is-invalid': errors.first_name}" placeholder="Enter User First Name" />

                                    <div class="text-danger mt-2" v-if="errors.first_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.first_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.last_name, 'text-muted-no': !errors.last_name}">
                                    Last Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!user.last_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="user.last_name" :class="{'form-control': true, 'is-invalid': errors.last_name}" placeholder="Enter User Last Name" />

                                    <div class="text-danger mt-2" v-if="errors.last_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.last_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.email, 'text-muted-no': !errors.email}">
                                    Email: <i class="fa fa-sm fa-asterisk text-danger" v-if="!user.email"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="user.email" :class="{'form-control': true, 'is-invalid': errors.email}" placeholder="Enter User Email" />

                                    <div class="text-danger mt-2" v-if="errors.email">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.email">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.timezone_id, 'text-muted-no': !errors.timezone_id}">
                                    Timezone: <i class="fa fa-sm fa-asterisk text-danger" v-if="!user.timezone_id"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="user.timezone_id" :options="timezoneOptions" :class="{'is-invalid': errors.timezone_id}" />

                                    <div class="text-danger mt-2" v-if="errors.timezone_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.timezone_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="user.is_active" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_active">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.is_active">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Permissions:</strong>
                        </div>
                        <div class="card-body">
                            <b-form-checkbox-group v-model="user_perms" :options="permissionOptions" name="permission_ids" plain stacked />
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveUser()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Create</template>
                </button>
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveUser()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                user: {},
                errors: {},
                permissions: [],
                user_perms: [],
                timezones: [],
            }
        },

        computed: {
            permissionOptions(){
                //Setup
                var options = [];

                //Main Loop
                for(var i = 0; i < this.permissions.length; i++)
                {
                    options.push({value: this.permissions[i].id, text: this.permissions[i].name + ' - ' + this.permissions[i].description});
                }

                //Send it
                return options;
            },

            timezoneOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Timezone --'}];

                //Build it
                for (var i = this.timezones.length - 1; i >= 0; i--)
                {
                    options.push({value: this.timezones[i].id, text: this.timezones[i].display_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getUser(){
                //Send it
                this.$http.get('/users/edit' + (this.id ? '/'+this.id : ''))
                    .then(response => {
                        //Set the user
                        this.user = response.data.user;
                        this.permissions = response.data.permissions;
                        this.user_perms = response.data.user_perms;
                        this.timezones = response.data.timezones;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveUser(){
                //Helpers
                this.saving = true;

                //Setup
                this.user.permissions = this.user_perms;

                //Send it
                this.$http
                .post('users/save', this.user)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('User ' + (this.user.id ? 'Updated' : 'Created') );

                    //Return to main list?
                    this.$router.push('/users/view/' + response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save User');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

        },

        mounted() {
            //get the user?
            this.getUser();
        }
    }
</script>
